export const TYPES = {
  SWITCH: "switch",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  RADIOCHECK: "radioCheck",
};

export default {
  TYPES,
};
